
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1606075732 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1556101844 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1575818880 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1684012025 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1184609144 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  return (n == 1 || !t0 && (i == 0
          || i == 1)) ? 'one' : 'other';
});
Globalize.a292916267 = messageFormatterFn((function(  ) {
  return function(d) { return "Rejse: Ferier, billige flyrejser, flybilletter og flypriser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1724178643 = messageFormatterFn((function(  ) {
  return function(d) { return "Point indløst"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1648138832 = messageFormatterFn((function(  ) {
  return function(d) { return "Point anvendes ikke"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1211569940 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk vindue"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1164079191 = messageFormatterFn((function(  ) {
  return function(d) { return "Til"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b422038141 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtjekning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1302534124 = messageFormatterFn((function(  ) {
  return function(d) { return "Udtjekning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1238458881 = messageFormatterFn((function(  ) {
  return function(d) { return "Dato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a26745941 = messageFormatterFn((function(  ) {
  return function(d) { return "Rejsende"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b395272751 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b450513573 = messageFormatterFn((function(  ) {
  return function(d) { return "Flere oplysninger om " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1015701112 = messageFormatterFn((function(  ) {
  return function(d) { return "Åbner " + d["0"] + " i et nyt vindue. Gå tilbage til det oprindelige vindue for at fortsætte."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1059675731 = messageFormatterFn((function(  ) {
  return function(d) { return "Søgeresultater"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1474853468 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en destination"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a743239946 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en gyldig indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1234174197 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg datoer for din rejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1700513307 = messageFormatterFn((function(  ) {
  return function(d) { return "Udtjekningsdatoen skal ligge efter indtjekningsdatoen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2052116451 = messageFormatterFn((function(  ) {
  return function(d) { return "Udtjekningsdatoen skal ligge maks. 28 dage efter indtjekningsdatoen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a615377049 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en gyldig udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1126557575 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg antal rejsende"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1111729264 = messageFormatterFn((function(  ) {
  return function(d) { return "Angiv alderen på barnet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b517258400 = messageFormatterFn((function(  ) {
  return function(d) { return "Angiv alderen på børnene"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b982542722 = messageFormatterFn((function(  ) {
  return function(d) { return "Opholdsdatoerne skal ligge inden for rejsedatoerne"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b636669597 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2055896885 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " værelser";}, one: function() { return number(d["0"]) + " værelse";}, two: function() { return number(d["0"]) + " værelser";}, few: function() { return number(d["0"]) + " værelser";}, many: function() { return number(d["0"]) + " værelser";}, other: function() { return number(d["0"]) + " værelser";} }) + ", " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " gæster";}, one: function() { return number(d["1"]) + " gæst";}, two: function() { return number(d["1"]) + " gæster";}, few: function() { return number(d["1"]) + " gæster";}, many: function() { return number(d["1"]) + " gæster";}, other: function() { return number(d["1"]) + " gæster";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b176930917 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " rejsende";}, one: function() { return number(d["1"]) + " rejsende";}, two: function() { return number(d["1"]) + " rejsende";}, few: function() { return number(d["1"]) + " rejsende";}, many: function() { return number(d["1"]) + " rejsende";}, other: function() { return number(d["1"]) + " rejsende";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1603054941 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " rejsende";}, one: function() { return number(d["1"]) + " rejsende";}, two: function() { return number(d["1"]) + " rejsende";}, few: function() { return number(d["1"]) + " rejsende";}, many: function() { return number(d["1"]) + " rejsende";}, other: function() { return number(d["1"]) + " rejsende";} }) + ", kæledyr"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a556957506 = messageFormatterFn((function(  ) {
  return function(d) { return "Rejsende"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b746551734 = messageFormatterFn((function(  ) {
  return function(d) { return "Værelse " + d["0"] + " tilføjet. Rediger oplysningerne om gæsten nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1108437014 = messageFormatterFn((function(  ) {
  return function(d) { return "Værelse fjernet. Rediger oplysningerne om gæsten på værelse " + d["0"] + " nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b423172666 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller, luk siden med oplysninger om antal gæster uden at gemme ændringerne. Eller rediger oplysningerne om gæsten nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1753712134 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2051124978 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem ændringerne, og luk siden med oplysninger om antal gæster og værelser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b178684898 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilføj endnu et værelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b742979965 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern værelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b737195253 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern værelse " + d["0"] + " ud af " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a569688823 = messageFormatterFn((function(  ) {
  return function(d) { return "Alder på barn " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b295660111 = messageFormatterFn((function(  ) {
  return function(d) { return "Værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a579006480 = messageFormatterFn((function(  ) {
  return function(d) { return "Værelse " + d["0"] + " af " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1121360018 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn " + d["0"] + ", alder opdateret til " + d["1"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1342917996 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1 år"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a920829094 = messageFormatterFn((function(  ) {
  return function(d) { return "Børn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a5218787 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alder 0 til 17)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a595003620 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " voksne";}, one: function() { return number(d["0"]) + " voksen";}, two: function() { return number(d["0"]) + " voksne";}, few: function() { return number(d["0"]) + " voksne";}, many: function() { return number(d["0"]) + " voksne";}, other: function() { return number(d["0"]) + " voksne";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a1639054186 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " børn";}, one: function() { return number(d["0"]) + " barn";}, two: function() { return number(d["0"]) + " børn";}, few: function() { return number(d["0"]) + " børn";}, many: function() { return number(d["0"]) + " børn";}, other: function() { return number(d["0"]) + " børn";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a752617260 = messageFormatterFn((function(  ) {
  return function(d) { return "Voksne"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1874328872 = messageFormatterFn((function(  ) {
  return function(d) { return "Reducer antallet af børn på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b609517522 = messageFormatterFn((function(  ) {
  return function(d) { return "Reducer antallet af voksne på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1654420732 = messageFormatterFn((function(  ) {
  return function(d) { return "Øg antallet af børn på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1062786314 = messageFormatterFn((function(  ) {
  return function(d) { return "Øg antallet af voksne på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1293426442 = messageFormatterFn((function(  ) {
  return function(d) { return "Kæledyr"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1757494106 = messageFormatterFn((function(  ) {
  return function(d) { return "Er kæledyr inkluderet?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1917367398 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1265717324 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1377783958 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er blevet føjet til dine lister"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1486948560 = messageFormatterFn((function(  ) {
  return function(d) { return "Åbner i et nyt vindue"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a56299035 = messageFormatterFn((function(  ) {
  return function(d) { return "Gæsteanmeldelser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a615826445 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller, gå tilbage til hoteloplysninger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b947328917 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjek tilgængelighed"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b310777706 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2122616164 = messageFormatterFn((function(  ) {
  return function(d) { return "Ændr søgning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1389126535 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en senere indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b334693163 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en tidligere indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a342001286 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en senere udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1396434658 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en tidligere udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1539834012 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen var " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b947245814 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen er " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1758313007 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen er nu " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1482350781 = messageFormatterFn((function(  ) {
  return function(d) { return "Prisen var " + d["0"] + ". Prisen er nu " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a326800650 = messageFormatterFn((function(  ) {
  return function(d) { return "pr. nat"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1738266906 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller, gå tilbage til hoteloplysninger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a533611710 = messageFormatterFn((function(  ) {
  return function(d) { return "Flere oplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1902973384 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk, gå tilbage til hoteloplysninger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1475076338 = messageFormatterFn((function(  ) {
  return function(d) { return "Noget gik galt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1153936852 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv at foretage en ny søgning."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a738496692 = messageFormatterFn((function(  ) {
  return function(d) { return "Se muligheder, og book"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1151227306 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a690563065 = messageFormatterFn((function(  ) {
  return function(d) { return "Du vil muligvis også kunne lide"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1702732648 = messageFormatterFn((function(  ) {
  return function(d) { return "Du betaler kun det, du ser her"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1303876055 = messageFormatterFn((function(  ) {
  return function(d) { return "Den samlede pris inkluderer alle skatter og gebyrer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b26806228 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk filtre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a54484660 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter og filtrer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1342413398 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1951983679 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1086285224 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik på ’Anvend’, eller gå tilbage for at lukke filtre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1483569958 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimumspris"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1932239724 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksimumspris"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2053280143 = messageFormatterFn((function(  ) {
  return function(d) { return "Antal stjerner"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b73190178 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter efter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1812277631 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrer efter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b717629119 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbage til hotelsøgning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2027605449 = messageFormatterFn((function(  ) {
  return function(d) { return "Søger blandt tusindvis af overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1179145550 = messageFormatterFn((function(  ) {
  return function(d) { return "Søger blandt tusindvis af pakkerejser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b448034570 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi sammenligner priser fra de mest populære biludlejningsfirmaer for at give dig de bedste tilbud"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1372356361 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi hjælper dig med at finde de bedste tilbud på udlejningsbiler"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b634211802 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " filtre";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filtre";}, few: function() { return number(d["0"]) + " filtre";}, many: function() { return number(d["0"]) + " filtre";}, other: function() { return number(d["0"]) + " filtre";} }) + " anvendt"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a1359555110 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter og filtrer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2020776934 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1089519303 = messageFormatterFn((function(  ) {
  return function(d) { return "Kort"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b946134711 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå videre til kort"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b571024668 = messageFormatterFn((function(  ) {
  return function(d) { return "Resultater indlæses"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b356512379 = messageFormatterFn((function(  ) {
  return function(d) { return "Resultaterne er blevet opdateret"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1988693205 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod en fejl ved indlæsningen af resultater"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1918235135 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen resultater"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b355968641 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg efter hoteller"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1986164210 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a722912455 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv disse datoer i stedet for"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a732129119 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere datoer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a694308003 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre datoer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1774092024 = messageFormatterFn((function(  ) {
  return function(d) { return "Privat vært"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b855264024 = messageFormatterFn((function(  ) {
  return function(d) { return "Professionel vært"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a470451980 = messageFormatterFn((function(  ) {
  return function(d) { return "Søgeresultater for hoteller i " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a632980656 = messageFormatterFn((function(  ) {
  return function(d) { return "Søgeresultater for ferieboliger i " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1667410945 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugyldige hotelsøgeresultater"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1645850305 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a933308601 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, vi fandt desværre ingen resultater. Prøv at justere dine filtre."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a169170621 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit valgte filter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1778757025 = messageFormatterFn((function(  ) {
  return function(d) { return "Dine valgte filtre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b236122785 = messageFormatterFn((function(  ) {
  return function(d) { return "Manglende destination"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1504872853 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + ","; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1692866037 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern alle filtre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b873280694 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " gæster";}, one: function() { return number(d["0"]) + " gæst";}, two: function() { return number(d["0"]) + " gæster";}, few: function() { return number(d["0"]) + " gæster";}, many: function() { return number(d["0"]) + " gæster";}, other: function() { return number(d["0"]) + " gæster";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b715403294 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, der er opstået en fejl fra vores side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b453997103 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a483224263 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem " + d["0"] + " på dine lister"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1726065725 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern " + d["0"] + " fra dine lister"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1895270555 = messageFormatterFn((function(  ) {
  return function(d) { return "Oplysninger om dit kommende ophold"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b159564548 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg i dette område"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b572253770 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod desværre en fejl. Prøv at søge igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1028160433 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk kort"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1105900543 = messageFormatterFn((function(  ) {
  return function(d) { return "Udvid kort"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a511813226 = messageFormatterFn((function(  ) {
  return function(d) { return "Udvid søgeresultater på kort"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b460528500 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis liste"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1054615817 = messageFormatterFn((function(  ) {
  return function(d) { return "Skjul søgeresultater på kort for at vise liste"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2101790667 = messageFormatterFn((function(  ) {
  return function(d) { return "Overnatningsstedets indhold indlæses"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1949397255 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { one: function() { return number(d["0"]) + " overnatningssted";}, other: function() { return number(d["0"]) + " overnatningssteder";} }) + "\nfra " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1227742000 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { one: function() { return number(d["0"]) + " overnatningssted";}, other: function() { return number(d["0"]) + " overnatningssteder";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b862251305 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1761568278 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1188236696 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, der er opstået en fejl"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1371716020 = messageFormatterFn((function(  ) {
  return function(d) { return "Næste element"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b185297608 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige element"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b670328997 = messageFormatterFn((function(  ) {
  return function(d) { return "Udtjekning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b688467588 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din rejse (" + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " værelser";}, one: function() { return number(d["0"]) + " værelse";}, two: function() { return number(d["0"]) + " værelser";}, few: function() { return number(d["0"]) + " værelser";}, many: function() { return number(d["0"]) + " værelser";}, other: function() { return number(d["0"]) + " værelser";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a1259301339 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din rejse (" + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " overnatningssteder";}, one: function() { return number(d["0"]) + " overnatningssted";}, two: function() { return number(d["0"]) + " overnatningssteder";}, few: function() { return number(d["0"]) + " overnatningssteder";}, many: function() { return number(d["0"]) + " overnatningssteder";}, other: function() { return number(d["0"]) + " overnatningssteder";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1468820927 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg dit næste værelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a14660446 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke længere tilgængelig"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a733428950 = messageFormatterFn((function(  ) {
  return function(d) { return "Nogle overnatningssteder er ikke længere tilgængelige for din rejse. Ønsker du at gå til betalingssiden alligevel?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b516069091 = messageFormatterFn((function(  ) {
  return function(d) { return "pr. værelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1431003675 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " gæster";}, one: function() { return number(d["0"]) + " gæst";}, two: function() { return number(d["0"]) + " gæster";}, few: function() { return number(d["0"]) + " gæster";}, many: function() { return number(d["0"]) + " gæster";}, other: function() { return number(d["0"]) + " gæster";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a883746633 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " værelser";}, one: function() { return number(d["0"]) + " værelse";}, two: function() { return number(d["0"]) + " værelser";}, few: function() { return number(d["0"]) + " værelser";}, many: function() { return number(d["0"]) + " værelser";}, other: function() { return number(d["0"]) + " værelser";} }) + ", " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " gæster";}, one: function() { return number(d["1"]) + " gæst";}, two: function() { return number(d["1"]) + " gæster";}, few: function() { return number(d["1"]) + " gæster";}, many: function() { return number(d["1"]) + " gæster";}, other: function() { return number(d["1"]) + " gæster";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a242184790 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " pr. nat"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1773048098 = messageFormatterFn((function(  ) {
  return function(d) { return "Skift værelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1085577198 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden er kopieret til udklipsholder."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1904969451 = messageFormatterFn((function(  ) {
  return function(d) { return "Beklager, der er opstået en fejl fra vores side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a157739796 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv venligst at søge igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a318793726 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b832675243 = messageFormatterFn((function(  ) {
  return function(d) { return "Afhentning og aflevering af udlejningsbil"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a22869474 = messageFormatterFn((function(  ) {
  return function(d) { return "Afhentningstidspunkt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a222569418 = messageFormatterFn((function(  ) {
  return function(d) { return "Afleveringstidspunkt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1714290839 = messageFormatterFn((function(  ) {
  return function(d) { return "Biludlejning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1240444246 = messageFormatterFn((function(  ) {
  return function(d) { return "Afleveringstidspunktet skal ligge mindst 2 timer efter afhentningstidspunktet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b167374206 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b167284833 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b166450685 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b166361312 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b165527164 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b165437791 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b164603643 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b164514270 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b163680122 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b163590749 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b162756601 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b162667228 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b161833080 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b161743707 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b160909559 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b160820186 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b159986038 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b159896665 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b159062517 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b158973144 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b138745055 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b138655682 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b137821534 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b137732161 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b136898013 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b136808640 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b135974492 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b135885119 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b135050971 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b134961598 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b134127450 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b134038077 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b133203929 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b133114556 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b132280408 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b132191035 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b131356887 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b131267514 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b130433366 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b130343993 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b110115904 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b110026531 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b109192383 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b109103010 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b108268862 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b108179489 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b107345341 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b107255968 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1127922115 = messageFormatterFn((function(  ) {
  return function(d) { return "Kun direkte flyrejser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2126721878 = messageFormatterFn((function(  ) {
  return function(d) { return "Foretrukken klasse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1002830210 = messageFormatterFn((function(  ) {
  return function(d) { return "Økonomiklasse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b336313655 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium-økonomiklasse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b134011294 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a478908170 = messageFormatterFn((function(  ) {
  return function(d) { return "Første klasse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b684974111 = messageFormatterFn((function(  ) {
  return function(d) { return "Rejsende"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1045518657 = messageFormatterFn((function(  ) {
  return function(d) { return "Der skal være mindst én rejsende (på min. 6 år) for hvert spædbarn på skødet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a196033660 = messageFormatterFn((function(  ) {
  return function(d) { return "Spædbørn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2136986117 = messageFormatterFn((function(  ) {
  return function(d) { return "(2-17 år)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1574958515 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 2 år"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b184100635 = messageFormatterFn((function(  ) {
  return function(d) { return "Alder på spædbarn " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1607646121 = messageFormatterFn((function(  ) {
  return function(d) { return "Reducer antallet af spædbørn på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a564094771 = messageFormatterFn((function(  ) {
  return function(d) { return "Øg antallet af spædbørn på værelse " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b786013499 = messageFormatterFn((function(  ) {
  return function(d) { return "Børn under 2 år skal enten sidde på skødet eller på eget sæde."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1090382509 = messageFormatterFn((function(  ) {
  return function(d) { return "På skød"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1106189291 = messageFormatterFn((function(  ) {
  return function(d) { return "På eget sæde"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b734664022 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyselskabets regler ang. alder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1582770442 = messageFormatterFn((function(  ) {
  return function(d) { return "Rejs fra"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2062671598 = messageFormatterFn((function(  ) {
  return function(d) { return "Afrejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2023769266 = messageFormatterFn((function(  ) {
  return function(d) { return "Hjemrejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a995370092 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg et afrejsested"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b908640006 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg har kun brug for et overnatningssted på en del af min rejse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1532395463 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl. Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1673074427 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg mindst 1 overnatningssted mere for at sammenligne"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1250860568 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["da-DK"], { one: function() { return number(d["1"]) + " valgt overnatningssted";}, other: function() { return number(d["1"]) + " valgte overnatningssteder";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1617934028 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " ud af " + plural(d["1"], 0, pluralFuncs["da-DK"], { one: function() { return number(d["1"]) + " valgt overnatningssted";}, other: function() { return number(d["1"]) + " valgte overnatningssteder";} }) + " til sammenligning"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a2060668354 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2052475494 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign valgte overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b584571596 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a474723688 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign valgte overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2077589466 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1361777282 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik for at vise overnatningsstedet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1991486329 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b524135869 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik for at fjerne overnatningsstedet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1792368455 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk sammenligning af overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a318831821 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b815453060 = messageFormatterFn((function(  ) {
  return function(d) { return "Se op til 5 overnatningssteder side om side, så du nemmere kan bestemme dig. Vælg \"Sammenlign\" for at begynde"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a490584200 = messageFormatterFn((function(  ) {
  return function(d) { return "Se op til 5 overnatningssteder side om side, så du nemmere kan bestemme dig."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a424124192 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv det nu"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a262773348 = messageFormatterFn((function(  ) {
  return function(d) { return "Begynd sammenligning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1280484776 = messageFormatterFn((function(  ) {
  return function(d) { return "Deaktiver sammenligning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1040147676 = messageFormatterFn((function(  ) {
  return function(d) { return "Måske senere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2006297831 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammenlign overnatningssteder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1963996190 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg \"Sammenlign\" i søgeresultaterne for at begynde."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b754514462 = messageFormatterFn((function(  ) {
  return function(d) { return "Se op til 5 overnatningssteder side om side."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a100304779 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke tilgængelig."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1158575528 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilgængelig for udtjekning den " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a152020311 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilgængelig for indtjekning den " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1055125033 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b282357829 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis alle overnatningsstedets faciliteter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1324969938 = messageFormatterFn((function(  ) {
  return function(d) { return "Gæsteanmeldelser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1087344365 = messageFormatterFn((function(  ) {
  return function(d) { return "Højdepunkter i området"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b820741354 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilpas dit ophold"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1353043638 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk afsnittet tilpas dit ophold"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b977077069 = messageFormatterFn((function(  ) {
  return function(d) { return "Meddelelse til værten"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1854521180 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod desværre en fejl"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a913817171 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2086173771 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1367279966 = messageFormatterFn((function(  ) {
  return function(d) { return "Annonce"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b304430992 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b375482433 = messageFormatterFn((function(  ) {
  return function(d) { return "Om denne annonce"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b93752861 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod et problem ved indlæsning af oplysningerne."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b209962635 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan ikke hente oplysningerne i øjeblikket."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1128569779 = messageFormatterFn((function(  ) {
  return function(d) { return "Gitter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1372023248 = messageFormatterFn((function(  ) {
  return function(d) { return "Gitteroversigt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b993422427 = messageFormatterFn((function(  ) {
  return function(d) { return "Liste"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1236875896 = messageFormatterFn((function(  ) {
  return function(d) { return "Listeoversigt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b46395914 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1949772175 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke valgt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a881999019 = messageFormatterFn((function(  ) {
  return function(d) { return "Det samlede beløb inkluderer alle skatter og gebyrer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b922428916 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen overraskelser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a153652674 = messageFormatterFn((function(  ) {
  return function(d) { return "Vrbos priser inkluderer alle gebyrer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a137556793 = messageFormatterFn((function(  ) {
  return function(d) { return "Du betaler kun det, du ser her"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1391413876 = messageFormatterFn((function(  ) {
  return function(d) { return "Du betaler kun det, du ser her"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a806781525 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikke alle rejsesider viser dig den samlede pris på forhånd. Det gør vi. Du betaler kun det, du ser her."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b488000103 = messageFormatterFn((function(  ) {
  return function(d) { return "Skatter tilføjes på betalingssiden."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1610960921 = messageFormatterFn((function(  ) {
  return function(d) { return "Søger du forskellige steder?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1815706808 = messageFormatterFn((function(  ) {
  return function(d) { return "Vores samlede priser inkluderer skatter og gebyrer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2132547557 = messageFormatterFn((function(  ) {
  return function(d) { return "Forsæt søgning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1151463315 = messageFormatterFn((function(  ) {
  return function(d) { return "Garanti for tryg og sikker reservation"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1962857287 = messageFormatterFn((function(  ) {
  return function(d) { return "Tingene går ikke altid efter planen, men vi er her for at hjælpe, hvis der opstår problemer med dit ophold."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1343579858 = messageFormatterFn((function(  ) {
  return function(d) { return "Få livesupport døgnet rundt til alt, hvad du har brug for før, under og efter dit ophold"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a669469346 = messageFormatterFn((function(  ) {
  return function(d) { return "Betalingsbeskyttelse og beskyttelse mod svindel for depositummer og gebyrer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a835961345 = messageFormatterFn((function(  ) {
  return function(d) { return "Dedikeret hjælp til at finde et nyt overnatningssted, hvis din reservation aflyses"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a558467304 = messageFormatterFn((function(  ) {
  return function(d) { return "Hjælp til akut overnatningssted, hvis du ikke kan få adgang til overnatningsstedet ved ankomst"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1827857992 = messageFormatterFn((function(  ) {
  return function(d) { return "Åbningstider"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a919687788 = messageFormatterFn((function(  ) {
  return function(d) { return "Søgeresultater for billeje i " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1869410738 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vi har føjet " + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " nætter";}, one: function() { return number(d["0"]) + " nat";}, two: function() { return number(d["0"]) + " nætter";}, few: function() { return number(d["0"]) + " nætter";}, many: function() { return number(d["0"]) + " nætter";}, other: function() { return number(d["0"]) + " nætter";} }) + " til dit ophold."; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1678327703 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Tilføj " + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " nætter";}, one: function() { return number(d["0"]) + " nat";}, two: function() { return number(d["0"]) + " nætter";}, few: function() { return number(d["0"]) + " nætter";}, many: function() { return number(d["0"]) + " nætter";}, other: function() { return number(d["0"]) + " nætter";} }) + ", og spar penge"; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b9468275 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne vært tilbyder en månedlig rabat, hvis du overnatter mindst 28 nætter."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1134302505 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne vært tilbyder en ugentlig rabat, hvis overnatter mindst 7 nætter."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1898682693 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Tilføj " + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " nætter";}, one: function() { return number(d["0"]) + " nat";}, two: function() { return number(d["0"]) + " nætter";}, few: function() { return number(d["0"]) + " nætter";}, many: function() { return number(d["0"]) + " nætter";}, other: function() { return number(d["0"]) + " nætter";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a1782972562 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b996546322 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a687085781 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2092433103 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a598077840 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2113526252 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b497808941 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1017639471 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a727160559 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2052358325 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b368726222 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1146722190 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a856243278 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1923275606 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b239643503 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1275804909 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a985325997 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1794192887 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b110560784 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1404887628 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1114408716 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1665110168 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a18521935 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1533970347 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1243491435 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1536027449 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a147604654 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1663053066 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1372574154 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1406944730 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a276687373 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1792135785 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1501656873 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1277862011 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a405770092 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1921218504 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1630739592 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1148779292 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a534852811 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2050301223 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1524807124 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1254711760 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a428920343 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1944368755 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1653889843 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1125629041 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a558003062 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2073451474 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a440959393 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1956407805 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b654927388 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a860521024 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b743935329 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a771513083 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1839822110 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b324373698 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b614852610 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a900595802 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1710739391 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b195290979 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b485769891 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1029678521 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1581656672 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b66208260 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b356687172 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1158761240 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1452573953 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a62874459 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b227604453 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1287843959 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1323491234 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a191957178 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b98521734 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1416926678 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1194408515 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a321039897 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a30560985 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1546009397 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1065325796 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a450122616 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a159643704 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1675092116 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b936243077 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a579205335 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a288726423 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1804174835 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b807160358 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a708288054 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a182793955 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1698242367 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b913092826 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a602355586 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a311876674 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1827325086 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b784010107 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a731438305 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a104252743 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b915988573 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a331940874 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b688300442 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1008338757 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b11902559 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1236026888 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a215785572 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a497804580 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b522436736 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a725492711 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b294748605 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b12729597 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1032970913 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a214958534 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b805282782 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b523263774 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1543505090 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b295575643 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1315816959 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1033797951 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2054039267 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b806109820 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1826351136 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1544332128 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1730393852 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1316643997 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1958081983 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2054866305 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1219859675 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1827178174 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1447547806 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1729566814 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a709325498 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1957254945 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a937013629 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1219032637 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a198791321 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1446720768 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a426479452 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1125321097 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a105079781 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1353009228 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a332767912 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a614786920 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b405454396 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a842475051 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b177766265 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1825066 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1022066382 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a225863065 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b794378251 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a902260948 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b117980368 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1129949079 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a109707763 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a391726771 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b628514545 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a619414902 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b400826414 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b118807406 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1139048722 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a108880725 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b911360591 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b629341583 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1649582899 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b401653452 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1421894768 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1139875760 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2134850220 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b912187629 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1932428945 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1650409937 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1624316043 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1422721806 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1852004174 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2134023182 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1113781866 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1933255983 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1341469997 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1623489005 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a603247689 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1851177136 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a830935820 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1112954828 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a92713512 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1340642959 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a320401643 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1019243288 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b998028 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1246931419 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a226690103 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a508709111 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b511532205 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a736397242 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b283844074 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a31252664 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b247109424 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a612490122 = messageFormatterFn((function(  ) {
  return function(d) { return "Afvis"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1694930584 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b636757926 = messageFormatterFn((function(  ) {
  return function(d) { return "Fjern"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b496566799 = messageFormatterFn((function(  ) {
  return function(d) { return "valgt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1851663804 = messageFormatterFn((function(  ) {
  return function(d) { return "Indlæser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a21493709 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a382226937 = messageFormatterFn((function(  ) {
  return function(d) { return "Åbner i et nyt vindue"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a171963617 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b152798866 = messageFormatterFn((function(  ) {
  return function(d) { return "Se mindre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1930255670 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1643716739 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a203782472 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Angiv udtjekningsdato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b46401975 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Klik på ’OK’ for at gemme datoerne og lukke kalenderen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1302532013 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1829154156 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1215149078 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", dato deaktiveret"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1815031641 = messageFormatterFn((function(  ) {
  return function(d) { return "Den nuværende måned er " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b928438498 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser nu " + d["0"] + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a281688546 = messageFormatterFn((function(  ) {
  return function(d) { return "Kalenderen er åben. Vælg en dato i tabellen nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1012291308 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller, luk kalenderen uden at gemme ændringerne. Eller vælg en dato i tabellen nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2025394844 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd valgte datoer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1383792359 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem ændringerne, og luk kalenderen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a129491136 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " nætter";}, one: function() { return number(d["0"]) + " nat";}, two: function() { return number(d["0"]) + " nætter";}, few: function() { return number(d["0"]) + " nætter";}, many: function() { return number(d["0"]) + " nætter";}, other: function() { return number(d["0"]) + " nætter";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b2130675056 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtjekning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a511064481 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå til betalingssiden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1568637186 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd datoer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b90835327 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1281738983 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1857090467 = messageFormatterFn((function(  ) {
  return function(d) { return "Rediger indtjekningsdatoen i tabellen nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1129412242 = messageFormatterFn((function(  ) {
  return function(d) { return "Rediger udtjekningsdatoen i tabellen nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b297618621 = messageFormatterFn((function(  ) {
  return function(d) { return "er valgt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1400311818 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. Luk kalenderen, eller ændr den valgte dato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1662696338 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " til " + d["1"] + " er valgt. Luk kalenderen, eller ændr de valgte datoer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1065808472 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt. " + d["1"] + ". Luk kalenderen, eller ændr den valgte dato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1967439264 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " til " + d["1"] + " er valgt. " + d["2"] + ". Luk kalenderen, eller ændr de valgte datoer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1283186937 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b14733056 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a921016943 = messageFormatterFn((function(  ) {
  return function(d) { return "tom"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1591126925 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige måned"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1996908431 = messageFormatterFn((function(  ) {
  return function(d) { return "Næste måned"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1254372098 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå direkte til " + d["0"] + " knap"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2146507946 = messageFormatterFn((function(  ) {
  return function(d) { return "Fra " + d["0"] + " til " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a883758311 = messageFormatterFn((function(  ) {
  return function(d) { return "Datoerne er blevet ryddet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b840364826 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Der " + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return "er " + number(d["0"]) + " results";}, one: function() { return "er " + number(d["0"]) + " resultat";}, two: function() { return "er " + number(d["0"]) + " resultater";}, few: function() { return "er " + number(d["0"]) + " resultater";}, many: function() { return "er " + number(d["0"]) + " resultater";}, other: function() { return "er " + number(d["0"]) + " resultater";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a249135825 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " Der er " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " resultater";}, one: function() { return number(d["1"]) + " resultat";}, two: function() { return number(d["1"]) + " resultater";}, few: function() { return number(d["1"]) + " resultater";}, many: function() { return number(d["1"]) + " resultater";}, other: function() { return number(d["1"]) + " resultater";} }) + ". Brug piletasterne eller swipe for at navigere i listen."; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1815520541 = messageFormatterFn((function(  ) {
  return function(d) { return "Søgningsfelt " + d["0"] + " – indtast søgeord."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1978209044 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har valgt " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a991831881 = messageFormatterFn((function(  ) {
  return function(d) { return "Menuen er lukket."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b221495025 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søgningsfelt " + d["0"] + " – viser nu " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " forslag";}, one: function() { return number(d["1"]) + " forslag";}, two: function() { return number(d["1"]) + " forslag";}, few: function() { return number(d["1"]) + " forslag";}, many: function() { return number(d["1"]) + " forslag";}, other: function() { return number(d["1"]) + " forslag";} }) + " til " + d["2"] + ". Naviger i listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b2108710072 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søgefeltet " + d["0"] + " er åbent. Viser " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " forslag";}, one: function() { return number(d["1"]) + " forslag";}, two: function() { return number(d["1"]) + " forslag";}, few: function() { return number(d["1"]) + " forslag";}, many: function() { return number(d["1"]) + " forslag";}, other: function() { return number(d["1"]) + " forslag";} }) + ". Angiv søgeord, eller naviger til listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b410369860 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Søgefeltet " + d["0"] + " er åbent. " + d["1"] + " er valgt i øjeblikket. Viser " + plural(d["2"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["2"]) + " forslag";}, one: function() { return number(d["2"]) + " forslag";}, two: function() { return number(d["2"]) + " forslag";}, few: function() { return number(d["2"]) + " forslag";}, many: function() { return number(d["2"]) + " forslag";}, other: function() { return number(d["2"]) + " forslag";} }) + " for " + d["3"] + ". Naviger til listen nedenfor."; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b254140758 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a456631135 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd alle"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b414197772 = messageFormatterFn((function(  ) {
  return function(d) { return "Følgende er valgt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b86263743 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " fjernet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1285940280 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle valg er blevet fjernet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1173051335 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har indtastet data i tekstfeltet. Foretag en søgning, eller vælg blandt kategorierne nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a88937754 = messageFormatterFn((function(  ) {
  return function(d) { return "Søg efter “" + d["0"] + "”"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1258380199 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingen resultater for “" + d["0"] + "”"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1177329937 = messageFormatterFn((function(  ) {
  return function(d) { return "Lufthavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b55626792 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1494356690 = messageFormatterFn((function(  ) {
  return function(d) { return "Interessepunkt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b157528535 = messageFormatterFn((function(  ) {
  return function(d) { return "I nærheden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1087103188 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv “" + d["0"] + "”"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1927722735 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/by"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a873804987 = messageFormatterFn((function(  ) {
  return function(d) { return "Lufthavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1562958899 = messageFormatterFn((function(  ) {
  return function(d) { return "Seværdighed"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a683936932 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1257590180 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b428163470 = messageFormatterFn((function(  ) {
  return function(d) { return "Togstation"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1598416513 = messageFormatterFn((function(  ) {
  return function(d) { return "Metrostation"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a776869477 = messageFormatterFn((function(  ) {
  return function(d) { return "Steder i nærheden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2108550724 = messageFormatterFn((function(  ) {
  return function(d) { return "Seneste søgninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1454624918 = messageFormatterFn((function(  ) {
  return function(d) { return "Andre søgte også efter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b487911221 = messageFormatterFn((function(  ) {
  return function(d) { return "Udforsk populære destinationer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b236421303 = messageFormatterFn((function(  ) {
  return function(d) { return "Populære destinationer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1379308691 = messageFormatterFn((function(  ) {
  return function(d) { return "Mest populære destinationer i øjeblikket"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1155180309 = messageFormatterFn((function(  ) {
  return function(d) { return "Din placering"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1862601490 = messageFormatterFn((function(  ) {
  return function(d) { return "Deling af placering er deaktiveret"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1458207746 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan ikke fastlægge din placering. Slå lokalitetstjenester til på din enhed, så vi kan fastlægge din placering, eller angiv en destination."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a492387174 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " værelser";}, one: function() { return number(d["0"]) + " værelse";}, two: function() { return number(d["0"]) + " værelser";}, few: function() { return number(d["0"]) + " værelser";}, many: function() { return number(d["0"]) + " værelser";}, other: function() { return number(d["0"]) + " værelser";} }) + ", " + plural(d["1"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["1"]) + " rejsende";}, one: function() { return number(d["1"]) + " rejsende";}, two: function() { return number(d["1"]) + " rejsende";}, few: function() { return number(d["1"]) + " rejsende";}, many: function() { return number(d["1"]) + " rejsende";}, other: function() { return number(d["1"]) + " rejsende";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.a2120827696 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " rejsende";}, one: function() { return number(d["0"]) + " rejsende";}, two: function() { return number(d["0"]) + " rejsende";}, few: function() { return number(d["0"]) + " rejsende";}, many: function() { return number(d["0"]) + " rejsende";}, other: function() { return number(d["0"]) + " rejsende";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1718888780 = messageFormatterFn((function(  ) {
  return function(d) { return "Værdien i feltet " + d["0"] + " er nu " + d["1"] + ". Værdien i feltet " + d["2"] + " er nu " + d["3"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a511340579 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt om på felterne " + d["0"] + " og " + d["1"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1763537456 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1449195317 = messageFormatterFn((function(  ) {
  return function(d) { return "Skjul adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1427046574 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser nu " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a707184935 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ud af " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1967479535 = messageFormatterFn((function(  ) {
  return function(d) { return "Billede " + d["0"] + " af " + d["1"] + ". " + d["2"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2068933844 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis næste billede"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b813520344 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis forrige billede"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b757009486 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis alle " + d["0"] + " billeder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1358637565 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vis " + plural(d["0"], 0, pluralFuncs["da-DK"], { zero: function() { return number(d["0"]) + " billeder";}, one: function() { return number(d["0"]) + " billede";}, two: function() { return number(d["0"]) + " billeder";}, few: function() { return "alle " + number(d["0"]) + " billeder";}, many: function() { return "alle " + number(d["0"]) + " billeder";}, other: function() { return "alle " + number(d["0"]) + " billeder";} }) + " for " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b133685184 = messageFormatterFn((function(  ) {
  return function(d) { return "Gennemført:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1220044178 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu:"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b603888868 = messageFormatterFn((function(  ) {
  return function(d) { return "Trin " + d["0"] + " af " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a546629760 = messageFormatterFn((function(  ) {
  return function(d) { return "Trin " + d["0"] + " af " + d["1"] + ":"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a35896129 = messageFormatterFn((function(  ) {
  return function(d) { return "Billede " + d["0"] + " af " + d["1"] + " " + d["2"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b403906562 = messageFormatterFn((function(  ) {
  return function(d) { return "Næste billede"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1639301638 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige billede"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1975589620 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", udvid til fuld skærm"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1688291808 = messageFormatterFn((function(  ) {
  return function(d) { return "Element " + d["0"] + ", udvid til fuld skærm"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1369325194 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuel side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1395265306 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis flere brødkrummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1433086422 = messageFormatterFn((function(  ) {
  return function(d) { return "Vis færre brødkrummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1013582003 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " procent, indlæser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1348712568 = messageFormatterFn((function(  ) {
  return function(d) { return "Indlæser"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b64917720 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b347995265 = messageFormatterFn((function(  ) {
  return function(d) { return "Der opstod en fejl."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1070867677 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv at se videoen på www.youtube.com, eller aktiver Javascript, hvis det er deaktiveret i din browser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1991113397 = messageFormatterFn((function(  ) {
  return function(d) { return "Afspil video"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a844188251 = messageFormatterFn((function(  ) {
  return function(d) { return "Sæt video på pause"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a547996211 = messageFormatterFn((function(  ) {
  return function(d) { return "Videoen indlæses"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1664604375 = messageFormatterFn((function(  ) {
  return function(d) { return "Photosphere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1291303587 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette er et 360-graders billede. Brug Control- og piletasterne eller Command- og piletasterne til at flytte rundt i billedet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b593278410 = messageFormatterFn((function(  ) {
  return function(d) { return "Viser i øjeblikket: " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a988251861 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet til venstre. Position: " + d["0"] + " grader"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1716251108 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet til højre. Position: " + d["0"] + " grader"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1203538217 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet op"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a768954544 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttet ned"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a359538559 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har nået toppen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1750152553 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har nået bunden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a555066347 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg alle rækker"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1787927498 = messageFormatterFn((function(  ) {
  return function(d) { return "Fravælg alle rækker"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a565921498 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter kolonne i faldende rækkefølge"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1758801676 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorter kolonne i stigende rækkefølge"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b433721380 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolonnen er nu i faldende rækkefølge"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1226385228 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolonnen er nu i stigende rækkefølge"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a144712764 = messageFormatterFn((function(  ) {
  return function(d) { return "Udvid række " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1062654907 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Viser " + d["0"] + " ud af " + plural(d["1"], 0, pluralFuncs["da-DK"], { one: function() { return number(d["1"]) + " produkt";}, other: function() { return number(d["1"]) + " produkter";} }); }
})(messageFormat.number, messageFormat.plural, {"da-DK": Globalize("da-DK").pluralGenerator()}), Globalize("da-DK").pluralGenerator({}));
Globalize.b1144360171 = messageFormatterFn((function(  ) {
  return function(d) { return "Dine nuværende måneder er " + d["0"] + " " + d["1"] + " og " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b420121555 = messageFormatterFn((function(  ) {
  return function(d) { return "Din nuværende måned er " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1828556792 = messageFormatterFn((function(  ) {
  return function(d) { return "Dine nuværende måneder er fra " + d["0"] + " " + d["1"] + " til " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a962250685 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtjekningsdatoen er ryddet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b643219014 = messageFormatterFn((function(  ) {
  return function(d) { return "Udtjekningsdatoen er ryddet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1886444453 = messageFormatterFn((function(  ) {
  return function(d) { return "Datoerne er ryddet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1728465600 = messageFormatterFn((function(  ) {
  return function(d) { return "Ryd datoer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b606954208 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1189060989 = messageFormatterFn((function(  ) {
  return function(d) { return "Næste"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b733862461 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2127108841 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå direkte til knappen OK"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a945359004 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå direkte til knappen " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b437527149 = messageFormatterFn((function(  ) {
  return function(d) { return "Næste måned"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1727750573 = messageFormatterFn((function(  ) {
  return function(d) { return "Forrige måned"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1173820700 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt som din indtjekningsdato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1351099713 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er valgt som din udtjekningsdato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b646045640 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke en gyldig indtjekningsdato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1868419341 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke en gyldig udtjekningsdato."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b880921340 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " er ikke tilgængelig."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1359104331 = messageFormatterFn((function(  ) {
  return function(d) { return "I dag"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2034247667 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt indtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a362565190 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt udtjekningsdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1414868719 = messageFormatterFn((function(  ) {
  return function(d) { return "Valgt dato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b143315509 = messageFormatterFn((function(  ) {
  return function(d) { return "Startdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b171097276 = messageFormatterFn((function(  ) {
  return function(d) { return "Slutdato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1339729659 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuller og luk kalenderen uden at gemme ændringerne. Eller vælg en dato blandt mulighederne nedenfor."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b581979574 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ud af " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1930037397 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryk på Esc for at ignorere."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a210541972 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryk på Esc for at skjule."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b520272221 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast et nummer, der er mindre end " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1063178690 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast et nummer, der er større end " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2075836971 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast et nummer mellem " + d["0"] + " og " + d["1"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1430656516 = messageFormatterFn((function(  ) {
  return function(d) { return "Påkrævet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b671387040 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a815228441 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbage! Log på med"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a978858529 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbage! Log på, og spar mindst 10% ekstra på tusindvis af overnatningssteder med medlemspriser."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1419566535 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2028007436 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b249558095 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du brug for en konto?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1450306881 = messageFormatterFn((function(  ) {
  return function(d) { return "Logger dig på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a254580478 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med Facebook"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1539803919 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med Google"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a536675231 = messageFormatterFn((function(  ) {
  return function(d) { return "Forbliv logget på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a361786724 = messageFormatterFn((function(  ) {
  return function(d) { return "Forbliv logget på (bruger cookies)"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a559473562 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a559832976 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilmeld dig"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b968437460 = messageFormatterFn((function(  ) {
  return function(d) { return "eller <a href=\"" + d["0"] + "\">log på med Facebook</a>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a362029750 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b617867831 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1607287327 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1359917668 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast kodeord"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1517189782 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv venligst igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a348935470 = messageFormatterFn((function(  ) {
  return function(d) { return "Ups, der opstod en fejl"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a398862604 = messageFormatterFn((function(  ) {
  return function(d) { return "Ret venligst fejlene nedenfor, og fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1726720669 = messageFormatterFn((function(  ) {
  return function(d) { return "Ret venligst de to fejl nedenfor, og fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a637578567 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på med din e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a266939564 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller log på med din e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1634864477 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a223119164 = messageFormatterFn((function(  ) {
  return function(d) { return "eller"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1858927918 = messageFormatterFn((function(  ) {
  return function(d) { return "Glemt din adgangskode?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1370249259 = messageFormatterFn((function(  ) {
  return function(d) { return "Er du ikke medlem?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1285356427 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1286190586 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at logge på accepterer jeg <a href=\"" + d["0"] + "\" target=\"_blank\"> vilkår og betingelser for " + d["1"] + " <span class=\"is-visually-hidden\">åbner i et nyt vindue</span></a>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1216006404 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at logge på min " + d["0"] + "-konto accepterer jeg " + d["2"] + "s <a href=\"" + d["1"] + "\" target=\"_blank\">vilkår for brug<span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a> og <a href=\"" + d["3"] + "\" target=\"_blank\">fortrolighedspolitik<span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a> såvel som <a href=\"" + d["4"] + "\" target=\"_blank\">vilkår og betingelser for " + d["5"] + "<span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a>. "; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1152431008 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilmeld dig <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">åbner i et nyt vindue</span></a> Ved at tilmelde mig accepterer jeg alle <a href=\"" + d["3"] + "\" target=\"_blank\">vilkår og betingelser. <span class=\"is-visually-hidden\">åbner i et nyt vindue</span></a>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b990479152 = messageFormatterFn((function(  ) {
  return function(d) { return "Vilkår gælder, links nederst på siden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1990746370 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjek din indbakke!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a931086723 = messageFormatterFn((function(  ) {
  return function(d) { return "Et link til nulstilling af din adgangskode er blevet sendt til " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a705441040 = messageFormatterFn((function(  ) {
  return function(d) { return "Send link igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2029484836 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl fra vores side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b334283799 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv venligst igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1458416324 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå tilbage"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a365726012 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er blevet sendt et nyt link."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a512273750 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto på " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1229681649 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto med"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b30735683 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto med din e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b515247754 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller opret en konto med din e-mailadresse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b37773010 = messageFormatterFn((function(  ) {
  return function(d) { return "For- og efternavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a440411608 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternavn og fornavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1573497469 = messageFormatterFn((function(  ) {
  return function(d) { return "Skal være mellem 8 og 30 tegn, og må ikke indeholde mellemrum"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2099867071 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a624802384 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du allerede en konto?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2696516 = messageFormatterFn((function(  ) {
  return function(d) { return "Ved at oprette en konto accepterer jeg " + d["0"] + "s <a href=\"" + d["1"] + "\" target=\"_blank\">vilkår for brug, <span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a> <a href=\"" + d["2"] + "\" target=\"_blank\">fortrolighedspolitikken, <span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a> samt <a href=\"" + d["3"] + "\" target=\"_blank\">vilkår og betingelser for " + d["4"] + ". <span class=\"is-visually-hidden\">Åbner i et nyt vindue</span></a>"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a554937771 = messageFormatterFn((function(  ) {
  return function(d) { return "Send mig e-mails med tilbud på rejser, særtilbud og andre oplysninger."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1621508661 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt dig et link via e-mail til at gennemføre oprettelsen af din konto. "; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b369699936 = messageFormatterFn((function(  ) {
  return function(d) { return "For at gennemføre oprettelsen af din konto, skal du klikke på linket i e-mailen sendt til " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b805163467 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstil din adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1024935013 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast din e-mailadresse, hvorefter vi sender dig et link til nulstilling af din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1238963035 = messageFormatterFn((function(  ) {
  return function(d) { return "Send link"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1689043435 = messageFormatterFn((function(  ) {
  return function(d) { return "eller betal som gæst"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1602392623 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg en ny adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a325027790 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en ny adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1940295497 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse: " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1419153345 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1914885583 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette link er desværre ikke længere gyldigt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b136853114 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmod om et nyt link for at nulstille din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1733139782 = messageFormatterFn((function(  ) {
  return function(d) { return "Send nyt link"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2034355953 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbage til login"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1719943056 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt dig et nyt link til at nulstille din adgangskode via e-mail."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a28995653 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvad er din e-mailadresse?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2038222282 = messageFormatterFn((function(  ) {
  return function(d) { return "Angiv venligst en e-mailadresse, så dine rejseudbydere eller " + d["0"] + " kan få fat i dig. Vi sender dig en sikkerhedskode for at bekræfte din identitet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1716960157 = messageFormatterFn((function(  ) {
  return function(d) { return "Du oprettede din konto hos " + d["0"] + " med et telefonnummer. Angiv venligst en e-mailadresse, så vi kan logge dig på. Vi sender dig en sikkerhedskode for at bekræfte din identitet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b922708208 = messageFormatterFn((function(  ) {
  return function(d) { return "Send sikkerhedskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1453266558 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast sikkerhedskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1846930666 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast venligst den sikkerhedskode, vi har sendt til " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1227273991 = messageFormatterFn((function(  ) {
  return function(d) { return "Sikkerhedskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a501562697 = messageFormatterFn((function(  ) {
  return function(d) { return "Send"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1650873729 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du ikke modtaget en e-mail?"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a231589861 = messageFormatterFn((function(  ) {
  return function(d) { return "Send ny kode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2108607382 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt en ny sikkerhedskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1744179527 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast en gyldig sikkerhedskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a420498816 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har nået det maksimale antal forsøg på at få gensendt sikkerhedskoden. Prøv venligst igen om 24 timer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1457518142 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har indtastet sikkerhedskoden forkert for mange gange i træk. Prøv venligst igen om 24 timer."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b778377411 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast venligst den korrekte sikkerhedskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a215944959 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-mailadresse er allerede blevet brugt til at oprette en konto på " + d["0"] + " via " + d["1"] + ". Prøv evt. at logge på med din " + d["1"] + "-konto, som er tilknyttet denne e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1968670504 = messageFormatterFn((function(  ) {
  return function(d) { return "Som sikkerhed beder vi dig om at nulstille din adgangskode for derefter at logge på."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1575420478 = messageFormatterFn((function(  ) {
  return function(d) { return "Hvis du har en konto hos " + d["0"] + ", sender vi en e- e-mail med et link til at nulstille din adgangskode."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1686874153 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbage, " + d["0"] + "!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1487006223 = messageFormatterFn((function(  ) {
  return function(d) { return "Din nye adgangskode er blevet gemt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1174500633 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt din søgning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b367087307 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen " + d["0"] + "."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2026052909 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl fra vores side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a970303714 = messageFormatterFn((function(  ) {
  return function(d) { return "Ret venligst de " + d["0"] + " fejl nedenfor for at fortsætte"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a663370137 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har indtastet en ukendt e-mailadresse eller en forkert adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1195583185 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunne desværre ikke oprette forbindelse til " + d["0"]; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b574874704 = messageFormatterFn((function(  ) {
  return function(d) { return "Din link til at nulstille din adgangskode er udløbet"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1278889590 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmod om et nyt link"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a371965436 = messageFormatterFn((function(  ) {
  return function(d) { return "Din session er udløbet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b9971812 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast for- og efternavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1935012124 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast efternavn og fornavn"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1496206386 = messageFormatterFn((function(  ) {
  return function(d) { return "Indtast navnet kun med bogstaver"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a537871358 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-mailadresse er allerede tilknyttet en konto hos " + d["0"] + ".  "; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1376957966 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode må ikke indeholde mellemrum."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a557463635 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode må ikke være den samme som din e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a137297809 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne adgangskode er nem at gætte sig til."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1327332664 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-mailadresse er allerede i brug."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1502313963 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskode er påkrævet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b742776699 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne adgangskode er ikke korrekt."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1229137663 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode skal være mindst " + d["0"] + " tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a572221613 = messageFormatterFn((function(  ) {
  return function(d) { return "Adgangskoden skal være mellem " + d["0"] + "og " + d["1"] + " tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a2116323203 = messageFormatterFn((function(  ) {
  return function(d) { return "Denne e-mailadresse er allerede blevet brugt til at oprette en konto på " + d["0"] + " via " + d["1"] + ". Brug venligst en anden e-mailadresse, eller log på med din " + d["1"] + "-konto, som er tilknyttet denne e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1336991415 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan desværre ikke logge dig på ved hjælp af dit Apple-ID. Vi arbejder på at kunne understøtte Apple-ID'er, som består af telefonnumre. Du bedes venligst logge på ved at bruge en anden metode i mellemtiden."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1171309439 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoen blev ikke fundet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1333794206 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadresse er påkrævet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a498446191 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk login-siden"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1011232485 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk oprettelse af konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a153939658 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilbage til forrige side"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a978967677 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk e-mailbekræftelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b549776675 = messageFormatterFn((function(  ) {
  return function(d) { return "Luk feltet til sikkerhedskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1144981479 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå til betalingssiden som gæst, eller log på"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a83001307 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg er ny kunde"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b344612102 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan stadig oprette en konto efter betaling."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b2009856775 = messageFormatterFn((function(  ) {
  return function(d) { return "Betal som gæst"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1590024211 = messageFormatterFn((function(  ) {
  return function(d) { return "Jeg er tilbagevendende kunde"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a952251779 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på, og optjen point på din reservation."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1021521606 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på og betal"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1167665055 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller fortsæt med"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a415904443 = messageFormatterFn((function(  ) {
  return function(d) { return "Velkommen tilbage!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1642118338 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på, eller opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1701145097 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1060450521 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt et link til nulstilling af din adgangskode til " + d["0"] + ". Det kan tage et par minutter om at nå frem. Tjek din spammappe, hvis ikke den dukker op i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1606560144 = messageFormatterFn((function(  ) {
  return function(d) { return "Nulstilling af adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1016917848 = messageFormatterFn((function(  ) {
  return function(d) { return "Din adgangskode skal bestå af mindst 8 tegn."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1706655730 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsæt med en tilknyttet konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1401357624 = messageFormatterFn((function(  ) {
  return function(d) { return "eller nulstil din adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1987702510 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjek din indbakke!"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b769571751 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har sendt et link til verificering til " + d["0"] + ", så du kan nulstille din adgangskode. Det kan tage et par minutter om at nå frem. Tjek din spammappe, hvis ikke den dukker op i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1145125853 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en adgangskode"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1606098739 = messageFormatterFn((function(  ) {
  return function(d) { return "Rediger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a142081099 = messageFormatterFn((function(  ) {
  return function(d) { return "Det ser ud til, at du har booket gennem os før. Af sikkerhedsmæssige grunde beder vi dig venligst verificere din e-mailadresse."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b771452819 = messageFormatterFn((function(  ) {
  return function(d) { return "Brug verificeringskoden, vi har sendt til " + d["0"] + ", for at færdiggøre oprettelsen af din konto. Den kan tage et par minutter om at nå frem. Tjek din spammappe, hvis ikke den dukker op i din indbakke."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b622939761 = messageFormatterFn((function(  ) {
  return function(d) { return "Mine rejseoplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1896982146 = messageFormatterFn((function(  ) {
  return function(d) { return "Mine kontooplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1931105000 = messageFormatterFn((function(  ) {
  return function(d) { return "Opdater personlige oplysninger, og tilpas præferencer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1586066558 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-oplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b874573402 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilføj Known Traveler-nummer eller Redress-nummer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1354566604 = messageFormatterFn((function(  ) {
  return function(d) { return "Personlige oplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b14598800 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilføj grundlæggende info og dine kontaktoplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1984652679 = messageFormatterFn((function(  ) {
  return function(d) { return "Flypræferencer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1348659563 = messageFormatterFn((function(  ) {
  return function(d) { return "Vælg indstillinger for at få en mere tilpasset brugeroplevelse"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1429916118 = messageFormatterFn((function(  ) {
  return function(d) { return "Loyalitetsprogrammer"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1602844082 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem dine bonusprogrammer og andre medlemskaber"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b754297784 = messageFormatterFn((function(  ) {
  return function(d) { return "Pasoplysninger"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a909843180 = messageFormatterFn((function(  ) {
  return function(d) { return "Gem dine pasoplysninger for at gøre din reservationsproces hurtigere"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1760128191 = messageFormatterFn((function(  ) {
  return function(d) { return "Administration af enheder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1862027611 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjek dine indloggede enheder"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b758005229 = messageFormatterFn((function(  ) {
  return function(d) { return "Log på for at se din konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1898770576 = messageFormatterFn((function(  ) {
  return function(d) { return "Opret en konto"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b140420911 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er desværre opstået en fejl."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1911840196 = messageFormatterFn((function(  ) {
  return function(d) { return "Det ser ud til, du er offline. Tjek din internetforbindelse, og prøv igen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b886512010 = messageFormatterFn((function(  ) {
  return function(d) { return "Prøv igen"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a531304551 = messageFormatterFn((function(  ) {
  return function(d) { return "Indlæser..."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1897809164 = messageFormatterFn((function(  ) {
  return function(d) { return "1 nat"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1213553004 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nætter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1661902848 = messageFormatterFn((function(  ) {
  return function(d) { return "OK, 1 nat valgt. Gem ændringerne, og luk kalenderen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a927000072 = messageFormatterFn((function(  ) {
  return function(d) { return "OK, " + d["0"] + " nætter valgt. Gem ændringerne, og luk kalenderen."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1626607099 = messageFormatterFn((function(  ) {
  return function(d) { return "Dato"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a988923182 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er " + d["0"] + " resultater"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1594867162 = messageFormatterFn((function(  ) {
  return function(d) { return "Der er 1 resultat"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a475619685 = messageFormatterFn((function(  ) {
  return function(d) { return "Dette indhold er betalt af " + d["0"] + " og produceret af Expedia Group Media Studio. Redaktionen hos Expedia Groups selskaber har ikke haft indflydelse på indholdet."; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1036964408 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a47561586 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyvning"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1961329050 = messageFormatterFn((function(  ) {
  return function(d) { return "Pakke"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a851981864 = messageFormatterFn((function(  ) {
  return function(d) { return "Bil"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a472312879 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviteter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.b1994046062 = messageFormatterFn((function(  ) {
  return function(d) { return "Krydstogter"; }
})(), Globalize("da-DK").pluralGenerator({}));
Globalize.a1389414050 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":"."});
Globalize.a119441801 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"y-MM-dd","timeSeparator":"."});
Globalize.a274867682 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":"."});
Globalize.a89587970 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/yy","timeSeparator":"."});
Globalize.b551380215 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/y","timeSeparator":"."});
Globalize.a708594334 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"d/MM/yy","timeSeparator":"."});
Globalize.a1000153781 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":"."});
Globalize.b490662251 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"d/M/yy","timeSeparator":"."});
Globalize.a1646659350 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d/M/y","timeSeparator":"."});
Globalize.b122300177 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":"."});
Globalize.b409654890 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"y/M/d","timeSeparator":"."});
Globalize.a329008706 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":"."});
Globalize.a1868413282 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.yy","timeSeparator":"."});
Globalize.a1999853225 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.y","timeSeparator":"."});
Globalize.b1443862131 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"d.MM.y","timeSeparator":"."});
Globalize.b546143049 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":"."});
Globalize.a2032865559 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"d.M.yy","timeSeparator":"."});
Globalize.a758232148 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d.M.y","timeSeparator":"."});
Globalize.a2126730722 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":"."});
Globalize.a856758473 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"y/MM/dd","timeSeparator":"."});
Globalize.a383149730 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":"."});
Globalize.b647728702 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"dd-MM-yy","timeSeparator":"."});
Globalize.a912644002 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":"."});
Globalize.a758582389 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":"."});
Globalize.b389411262 = dateToPartsFormatterFn({"2":Globalize("da-DK").numberFormatter({"raw":"00"}),"4":Globalize("da-DK").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":"."});
Globalize.a1294093437 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":".","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.a1565734754 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":".","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}}});
Globalize.a312489314 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a1588976318 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":"."});
Globalize.a1363832917 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"}),"2":Globalize("da-DK").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":"."});
Globalize.a866626124 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":".","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1076244925 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a1060875416 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a449803144 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":".","months":{"M":{"4":{"1":"januar","2":"februar","3":"marts","4":"april","5":"maj","6":"juni","7":"juli","8":"august","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a450488337 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":".","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1368146804 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d. MMM","timeSeparator":".","days":{"E":{"4":{"sun":"søndag","mon":"mandag","tue":"tirsdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lørdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1068856757 = dateToPartsFormatterFn({"1":Globalize("da-DK").numberFormatter({"raw":"0"})}, {"pattern":"E d. MMM","timeSeparator":".","days":{"E":{"1":{"sun":"søn.","mon":"man.","tue":"tir.","wed":"ons.","thu":"tor.","fri":"fre.","sat":"lør."}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mar.","4":"apr.","5":"maj","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1768127801 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a870724178 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"y-MM-dd"}));
Globalize.a653581433 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1904505177 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd/MM/yy"}));
Globalize.a199902162 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd/MM/y"}));
Globalize.a1459876711 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d/MM/yy"}));
Globalize.b1479896308 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b882069332 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d/M/yy"}));
Globalize.a1495485983 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d/M/y"}));
Globalize.a1692617030 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b560828257 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"y/M/d"}));
Globalize.a707722457 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b611636807 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd.MM.yy"}));
Globalize.b1543831694 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd.MM.y"}));
Globalize.b1835269212 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d.MM.y"}));
Globalize.a1268774158 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1641458478 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d.M.yy"}));
Globalize.a607058781 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d.M.y"}));
Globalize.b1789522823 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1608040850 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"y/MM/dd"}));
Globalize.a761863481 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a1167188505 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"dd-MM-yy"}));
Globalize.a1291357753 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b1721467700 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b10697511 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1142920070 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a729574201 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b523671239 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b2122707385 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"d"}));
Globalize.a972425836 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1294484693 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1454958676 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b83900191 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a828516895 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a829202088 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1985877355 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a1447570508 = dateFormatterFn(Globalize("da-DK").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b912777752 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1399449603 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y-MM-dd","digitsRe":/\d/});
Globalize.b2027324120 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1115124168 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yy","digitsRe":/\d/});
Globalize.a728627587 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/y","digitsRe":/\d/});
Globalize.a1988602136 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM/yy","digitsRe":/\d/});
Globalize.a2025689979 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b726466341 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yy","digitsRe":/\d/});
Globalize.b993346544 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/y","digitsRe":/\d/});
Globalize.a903236021 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1245306512 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/M/d","digitsRe":/\d/});
Globalize.b1973183096 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1401017816 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yy","digitsRe":/\d/});
Globalize.b1015106269 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.y","digitsRe":/\d/});
Globalize.b1679666221 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.MM.y","digitsRe":/\d/});
Globalize.a479393149 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1797061469 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yy","digitsRe":/\d/});
Globalize.b1881773746 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.y","digitsRe":/\d/});
Globalize.b175461080 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a2136766275 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/MM/dd","digitsRe":/\d/});
Globalize.b1919042072 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a377807496 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yy","digitsRe":/\d/});
Globalize.b1389547800 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1784118587 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1603364232 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1345912457 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.b181994712 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]]});
Globalize.b1435240152 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a614472888 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1128028827 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1701490106 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.b1225946877 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1587593710 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1852388658 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["11",/^november/],["12",/^december/],["2",/^februar/],["10",/^oktober/],["1",/^januar/],["8",/^august/],["3",/^marts/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b1851703465 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.a368629638 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^tirsdag/],["thu",/^torsdag/],["sun",/^søndag/],["mon",/^mandag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lørdag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
Globalize.b1233335045 = dateParserFn(Globalize("da-DK").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^søn\./],["mon",/^man\./],["tue",/^tir\./],["wed",/^ons\./],["thu",/^tor\./],["fri",/^fre\./],["sat",/^lør\./]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mar\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^maj/]]});
module.exports = Globalize;
